import React from "react";
import { Odd } from "../../../../models/Odd_response_model.tsx";
import { useBetContext } from "../../../../context/ParlayBetContext.tsx";
import { SelectedOddParlay } from "./SelectedOddParlay.tsx";

interface IBetSelectorComponent {
    availableOdds: Odd[],
    onRequestBetsModal: Function,
    slotIndex: number
}

export function ParlaySelectorComponent(props: IBetSelectorComponent) {
    const { bets } = useBetContext();
    const { onRequestBetsModal, availableOdds, slotIndex } = props;

    const underSelection = availableOdds.filter(o => o.selection_line === "under");
    const overSelection = availableOdds.filter(o => o.selection_line === "over");
    const noSelections = availableOdds.filter(o => o.selection_line === null);

    const predicate = (o: Odd) => {
        const bet = bets.find(bet => bet.id_selection === o.id);

        if (bet !== undefined) {
            return true;
        }
        return o.is_main;
    }

    const odds = [
        overSelection.filter(o => predicate(o)),
        underSelection.filter(o => predicate(o)),
        noSelections.filter(o => predicate(o))
    ];

    return (
        <>
            {
                odds.length > 0 && (odds.map((selections, index) => {

                    if (selections.length > 1) {
                        selections = selections.filter(o => !o.is_main);
                    };

                    return selections.map((o, i) => {
                        const bet = bets.find(bet => bet.id_selection === o.id);

                        return (
                            <div className="market-container-flex"
                                key={i} >
                                <SelectedOddParlay
                                    o={o}
                                    currentBet={bet}
                                    onRequestBetsModal={onRequestBetsModal}
                                    slotIndex={slotIndex}
                                />
                            </div>
                        );
                    });
                }))
            }

        </>
    );
}
